// extracted by mini-css-extract-plugin
export var link = "_t6-0";